import React from 'react';

import { Position } from '../../../shared/modal/PositionModal';
import { FieldConfigModal } from './FieldConfigModal';

interface SystemIdModalProps {
    isOpen: boolean;
    closeModal: () => void;
    position: Position | null;
    systemId: string;
    updateSystemId: (val: string) => void;
    disableInputs: boolean;
}

export const SystemIdModal: React.FC<SystemIdModalProps> = ({ closeModal, isOpen, position, updateSystemId, systemId, disableInputs }) => (
    <FieldConfigModal
        isOpen={isOpen}
        position={position}
        closeModal={closeModal}
        value={systemId}
        updateValue={updateSystemId}
        disabled={disableInputs}
        headerLabel='System ID'
        description='The systemId is what helps us to identify a field when referencing in other areas of the application such as the CDM export or AI Queries. These should be unique within a dataset instance tree and should be a shorthand representation of the field they are linked to. For Example: minimumTransferAmount for field Minimum Transfer Amount.'
        placeholder='Add a system id...'
        testId='system-id'
    />
);
